var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 110,
    viewBox: "0 0 98 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6654 104.445C92.6654 96.8279 92.6654 93.0191 91.7252 89.9199C89.6085 82.9419 84.1479 77.4814 77.1699 75.3646C74.0707 74.4245 70.262 74.4245 62.6445 74.4245H35.3529C27.7354 74.4245 23.9267 74.4245 20.8275 75.3646C13.8495 77.4814 8.38892 82.9419 6.27217 89.9199C5.33203 93.0191 5.33203 96.8279 5.33203 104.445M73.5612 30.7578C73.5612 44.3233 62.5642 55.3203 48.9987 55.3203C35.4332 55.3203 24.4362 44.3233 24.4362 30.7578C24.4362 17.1923 35.4332 6.19531 48.9987 6.19531C62.5642 6.19531 73.5612 17.1923 73.5612 30.7578Z",
    stroke: "#00FFFF",
    strokeWidth: 10.6381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2aa271fa3e0d72caee8da256f8f7c690.svg";
export { ForwardRef as ReactComponent };